<template>
    <div>
        <row>
            <column md="4">
                <div class="sidebar-details">
                    <md-toolbar :md-elevation="2" class="p-0">
                        <md-list>
                            <md-list-item>
                                <md-avatar class="md-avatar-icon md-large md-primary">
                                    <img v-if="userDetails.profileImage != ''" :src="getImgUrl(userDetails.profileImage)" alt="Avatar">
                                    <md-ripple v-else>{{ formatName | uppercase }}</md-ripple>
                                </md-avatar>
                                <span class="md-list-item-text">{{ userDetails.firstName | capitalize }} {{ userDetails.lastName | capitalize }}</span>
                            </md-list-item>
                        </md-list>
                    </md-toolbar>
                    <md-list class="md-double-line">
                        <md-subheader>{{$t('email')}}</md-subheader>
                        <md-list-item>
                            <md-icon class="md-primary">email</md-icon>
                            <div class="md-list-item-text">
                                <span>{{ userDetails.email }}</span>
                            </div>
                        </md-list-item>
                    </md-list>
                </div>
            </column>
            <column md="8">
                <form novalidate class="md-layout" @submit.prevent="validatePassword">
                    <md-card class="md-layout-item mx-auto user-details">
                        <md-card-header>
                            <div v-show="message" v-html="alertMessage" :class="alertClass" class="alert fade show" role="alert"></div>
                            <h3 class="mb-4 mt-4 font-weight-bold text-uppercase"><strong>{{$t('title_change_password')}}</strong></h3>
                        </md-card-header>
                        <md-card-content class="ml-4 mr-4">
                            <strong>{{$t('save_your_password')}}</strong>
                            <p class="font-small pb-3 ml-1 small grey-text">{{$t('password_validation_requirement')}}</p>                            
                            <div class="md-layout md-gutter">
                                <div class="md-layout-item md-small-size-100">
                                <md-field :class="getValidationClass('password')">
                                    <md-icon>vpn_key</md-icon>
                                    <label for="password">{{$t('label_password')}}</label>
                                    <md-input type="password" name="password" id="password" v-model="form.password" :disabled="sending" />
                                    <span class="md-error" v-if="!$v.form.password.required">{{$t('required.password')}}</span>
                                    <span class="md-error" v-else-if="!$v.form.password.minlength">{{$t('invalid.password')}}</span>
                                    <span class="md-error" v-else-if="!$v.form.password.strongPassword">{{$t('invalid.password')}}</span>
                                </md-field>                                
                                </div>
                            </div>
                            <div class="md-layout md-gutter">
                                <div class="md-layout-item md-small-size-100">
                                <md-field :class="getValidationClass('confirm_password')">
                                    <md-icon>vpn_key</md-icon>
                                    <label for="confirm_password">{{$t('label_confirm_password')}}</label>
                                    <md-input type="password" name="confirm_password" id="confirm_password" v-model="form.confirm_password" :disabled="sending" />
                                    <span class="md-error" v-if="!$v.form.confirm_password.required">{{$t('required.confirm_password')}}</span>
                                    <span class="md-error" v-else-if="!$v.form.confirm_password.sameAsPassword">{{$t('invalid.confirm_password')}}</span>
                                </md-field>
                                </div>
                            </div>                            
                        </md-card-content>
                        <md-progress-bar md-mode="indeterminate" v-if="sending" />
                        <div class="mt-0 mr-4 ml-4 mb-4">
                            <div class="text-center mb-3">
                                <btn :disabled="sending" type="submit" size="sm" color="info" class="btn-rounded">{{$t('register')}}</btn>
                            </div>
                        </div>
                    </md-card>
                </form>
            </column>
        </row>
        <PaymentInfoModal />
    </div>
</template>

<script>
import axios from 'axios'
import { BASE_API } from '../helpers/base'
import { Row, Column, Btn, Card, CardBody } from 'mdbvue';
import { validationMixin } from 'vuelidate'
import { required, minLength, sameAs } from 'vuelidate/lib/validators'
import { mapGetters, mapActions } from 'vuex'
import {getLoggedUser, changePassword} from '../services/User.service'
import PaymentInfoModal from '@/components/PaymentInfoModal'

const strongPassword = (value, component) => {
  if (!value) return false
  const hasMinLength = value.length >= 6
  const hasDigit = /\d/.test(value)
  const hasLetter = /[a-zA-Z]/.test(value)
  return hasMinLength && hasDigit && hasLetter
}

export default {
    name: 'ChangePwd',
    mixins: [validationMixin],
    data: () => ({
        userDetails: {
            firstName: '',
            lastName: '',
            profileImage: '',
            email: ''
        },
        form: {
            password: null,
            confirm_password: null
        },
        sending: false,
        message: false,
        alertMessage: '',
        alertClass: '',
    }),
    validations: {
        form: {
            password: {
                required,
                minLength: minLength(6),
                strongPassword
            },
            confirm_password: {
                required,
                sameAsPassword: sameAs('password')
            }
        }
    },
    computed: {
        ...mapGetters(['currentUser']),
        formatName(){
            return `${this.userDetails.firstName.charAt(0)}${this.userDetails.lastName.charAt(0)}`;
        }
    },
    methods: {
        ...mapActions(['setUserDetails']),
        getImgUrl(pic) {
            return 'https://gestion.comcolors.com/img/avatars/'+pic
        },
        getUserData (){
            if(localStorage.getItem('userId')) {
                const userId=localStorage.getItem('userId');
                getLoggedUser(userId).then(response => {
                    this.setUserDetails(response.data.user_info);
                    const user = response.data.user_info
                    this.userDetails.firstName = user.prenom
                    this.userDetails.lastName = user.nom
                    this.userDetails.profileImage = user.fichier
                    this.userDetails.email = user.email
                }).catch(error => {
                    console.log(error.data.user_info);
                })
            }
        },
        changeUserPassword () {
            this.sending = true
            this.message = false
            if(localStorage.getItem('userId')) {
                let data = {
                    password: this.form.password,
                    confirm_password: this.form.confirm_password
                }
                const userId = localStorage.getItem('userId');
                if(this.form.password == this.form.confirm_password){
                    changePassword(userId,data).then(response => {
                        console.log(response.data);
                        this.sending = false
                        this.message = true
                        this.alertMessage = response.data.message
                        this.alertClass = 'alert-success'

                        //this.$router.push({name:'Questionnaire'});
                    }).catch(error => {
                        this.$store.dispatch('logout');
                        console.log(error.response);
                    })
                }else{
                    this.sending = false
                    this.message = true
                    this.alertClass = 'alert-danger'
                    this.alertMessage = this.$t('terms_of_use_error_message')
                    this.backToTop();

                    window.setTimeout(function(){
                        $('.alert').fadeIn(function(){
                            setTimeout(function(){
                                $(".alert").fadeOut(500, function(){
                                    $(this).hide();
                                });
                            }, 4000)
                        })
                    })
                }
            }
        },
        getValidationClass (fieldName) {
            const field = this.$v.form[fieldName]

            if (field) {
                return {
                'md-invalid': field.$invalid && field.$dirty
                }
            }
        },
        validatePassword () {
            this.$v.$touch()

            if (!this.$v.$invalid) {
                this.changeUserPassword()
            }
        },
        backToTop(){
            $('html,body').stop().animate({
                scrollTop: 0
            }, 'slow', 'swing');
        }
    },
    components: {
        Btn, Row, Column, PaymentInfoModal
    },
    mounted(){
        this.getUserData();
    }
}
</script>

<style scoped>
.sidebar-details {
vertical-align: top;
overflow: auto;
border: 1px solid rgba(0,0,0,.12)
}
.sidebar-details .md-list-item-text {
white-space: normal;
}
.md-progress-bar {
position: absolute;
top: 0;
right: 0;
left: 0;
}
ul.md-list.md-theme-default {
width: 100%;
}
@media (max-width: 767px){
.user-details .md-card-content {
margin: 0 !important;
}
}
.newsletter {
  justify-content: left;
  align-items: normal;
}
.terms-of-use {
  float:left;
  margin-left: 9%;
}
</style>



// WEBPACK FOOTER //
// src/components/ChangePwd.vue